var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.167 1.667h4.166v17.5H1.667v-17.5h4.166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5l1.667 1.667 3.333-3.334M5.833.833v5h2.5a1.666 1.666 0 1 1 3.334 0h2.5v-5H5.833z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksGrey);
export default __webpack_public_path__ + "static/media/tasks-grey.49591f954fa654fd00eadae63c42c476.svg";
export { ForwardRef as ReactComponent };